import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Row = styled.div`
  display: flex;
`;

const SkeletonWrapper = styled(Row)`
  flex: 1 1 0px;
  flex-wrap: wrap;
  overflow-x: hidden;

  @keyFrames skeletonMove {
    0% {
      background-position-x: 100%;
    }
    100% {
      background-position-x: -200%;
    }
  }

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    flex: unset;
  }
`;

const SkeletonCard = styled(Row)`
  margin-right: 10px;
  margin-bottom: 10px;
  flex: 0 0 calc(50% - 10px);

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    flex: 0 0 calc(100%);
  }
`;

const SkeletonImage = styled.div`
  flex: 1 1 0px;
  height: 90px;
  background-color: #e6e6e6;

  background-image: linear-gradient(90deg, #e6e6e6 8%, #f7f7f7 18%, #e6e6e6 33%);
  background-repeat: no-repeat;
  animation: 1.2s skeletonMove linear infinite;
  background-size: 200% 100%;
`;

class Skeleton extends React.Component {

  static propTypes = {
    mobileBreakpoint: PropTypes.number,
    nbCols: PropTypes.number
  }

  render = () => {

    const children = [];
    for (let i = 0; i < (this.props.nbCols || 1); i++) {
      children.push((<SkeletonCard mobileBreakpoint={this.props.mobileBreakpoint}>
        <SkeletonImage></SkeletonImage>
      </SkeletonCard>));

    }
    return (
      <SkeletonWrapper>
        {children.map((child, idx) => <React.Fragment key={idx}>
          {child}
        </React.Fragment>)}
      </SkeletonWrapper>

    );
  }

}
export default Skeleton;
